import { Button, Dialog, Form, Input, Text } from '@southfields-digital/mpxlive-components';
import { useState } from 'react';

import styles from './RundownDialog.module.scss';

interface IRundownDialogProps {
  dialogTitle: string;
  dialogSubtitle: string;
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (initialName: string) => void;
  initialValue?: string;
}

export default function RundownDialog({
  dialogTitle,
  dialogSubtitle,
  isOpen,
  initialValue,
  onClose,
  onSubmit,
}: IRundownDialogProps) {
  const [value, setValue] = useState(initialValue || '');

  const handleStopPointerEvents = (event: React.PointerEvent) => {
    event.stopPropagation();
  };

  const handleSubmitForm = () => {
    onSubmit(value);
    setValue('');
  };

  return (
    <Dialog
      backdrop
      open={isOpen}
      onClose={onClose}
      onPointerDownCapture={handleStopPointerEvents}
      onPointerMoveCapture={handleStopPointerEvents}
    >
      <Dialog.Panel>
        <Dialog.Title>{dialogTitle}</Dialog.Title>
        <Dialog.Description>
          <Text>{dialogSubtitle}</Text>
        </Dialog.Description>
        <Form onSubmit={handleSubmitForm}>
          <Input
            type="text"
            value={value}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setValue(e.currentTarget.value)}
            className={styles.Input}
          />
          <Button variant="primary" className={styles.Button} type="submit">
            Submit
          </Button>
        </Form>
      </Dialog.Panel>
    </Dialog>
  );
}
